import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@environments/environment';
import { CompanyCard } from '@type/company.type';
import { basePostRequest } from '@type/request.type';
import { joinUrls } from '@utils/urls';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CompaniesService {
  private http = inject(HttpClient);

  getCompaniesList(q?: Record<string, string>): Observable<{ companies: CompanyCard[] }> {
    return this.http.post<{ companies: CompanyCard[] }>(joinUrls(environment.urls.companies, environment.urls.index), {
      ...basePostRequest,
      q,
      per_page: -1,
    });
  }
}
